import React from "react";
import { Link } from "react-router-dom";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import FeaturedTable from "./FeaturedTable.jsx";
import "./FeaturedContent.scss";

const FeaturedInfectiousDiseaseAssays = () => {
  return (
    <AppWrapper
      id="featured-infectious-disease"
      pageTitle="Featured Infectious Disease Assays"
      pageKeywords="Infectious Disease, SARS-CoV-2, Influenza A/B, Ebola and Zika, curated list"
      pageDescription="ddPCR Expert Design Assays for SARS-CoV-2, Influenza A/B, Ebola and Zika have been designed by Bio-Rad's ddPCR experts and are not wet-lab validated. It is recommended that the assays be validated prior to use by the end user."
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div id="page-header">
          <div id="page-header-inner" className="row align-items-center">
            <div className="col-md-12">
              <h1>Infectious Disease</h1>
              <h2 className="h3">
                Your partner from discovery to therapeutics
              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="copy">
              Virus quantification and detection are critical for effectively
              identifying, monitoring, and mitigating viruses. Viral infections
              can ebb and flow seasonally in the population or spread rapidly in
              a seemingly sudden and intense outbreak, such as the recent
              outbreaks of SARS-CoV-2, Zika and Ebola viruses. During such
              outbreaks, testing becomes important for understanding and
              managing the spread and treatment of that virus. Sensitivity and
              specificity are important for responding effectively. However, RNA
              viruses, such as SARS-CoV-2, Ebola and Zika, have high variability
              and need to be detected in high backgrounds of DNA/RNA. Droplet
              Digital PCR excels at low level quantification and provides
              precise, reproducible results with high confidence. The ddPCR
              Expert Design Assays have been designed by Bio-Rad's ddPCR experts
              and are not wet-lab validated. It is recommended that the assays
              be validated prior to use by the end user. Information and
              suggested protocol for each assay is available on the assay
              details page. ​
            </div>
            <h2 className="h3 in-page">
              Infectious Disease Kits and Expert Design Assays
            </h2>
            <FeaturedTable type="infectiousDisease" />
          </div>
        </div>
      </div>
    </AppWrapper>
  );
};

export default FeaturedInfectiousDiseaseAssays;
